import { render, staticRenderFns } from "./selectSkus.vue?vue&type=template&id=22217574"
import script from "./selectSkus.vue?vue&type=script&lang=js"
export * from "./selectSkus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports